import React, { useContext, useEffect, useRef, useState } from "react";
import EventMiniCard from "./components/EventMiniCard";
import MoreButton from "./components/moreButton";
import "./style.css";
import Header from "../../components/Header";
import HeadingOfEvent from "../../components/HeadingOfEvent";
import HomeImageContent from "../../components/HomeImageContent";
import BreadCrumb from "../../components/BreadCrumb";
import { filterDataContext } from "../../App";
import { useSearchParams } from "react-router-dom";
import EventsPagination from "./Pagination";

const EventsPage = () => {
  const { filteredEvents, selectedSport, containerRef } =
    useContext(filterDataContext);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    let sport_Type = searchParams.get("sport_type");
    if (!sport_Type) {
      setSearchParams({ sport_type: "football" });
    }
  }, []);

  return (
    <>
      <HomeImageContent />
      <div className="Events_show" ref={containerRef}>
        <div className="container_events">
          <div className="header_sec">
            <BreadCrumb />
            <HeadingOfEvent title={searchParams.get("sport_type")} />
          </div>
          <div className="team_and_competiotions">
            <EventsPagination
              searchParams={searchParams}
              setSearchParams={setSearchParams}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EventsPage;
